module.exports = __webpack_public_path__ + "img/profile.4d256293.svg";